import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, ErrorBox } from "@/components/common";

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [token, setToken] = useState(params.get("token") || "");
  const [preview, setPreview] = useState(null);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) return;
    api.get(`/auth/invite/${encodeURIComponent(token)}`).then((r) => { setPreview(r.data); setError(null); }).catch((e) => { setPreview(null); setError(errMsg(e)); });
  }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(null);
    try {
      await api.post("/auth/invite/accept", { token, name, password });
      await refresh(); navigate("/today");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-6" data-testid="accept-invite-card">
        <h1 className="text-xl font-heading font-semibold">Join your organisation</h1>
        {preview ? <p className="text-sm text-muted-foreground mt-1">You were invited to <b>{preview.org_name}</b> as <b>{preview.role.replace("_", " ")}</b> ({preview.email}).</p>
                 : <p className="text-sm text-muted-foreground mt-1">Paste the invite token from the link you received.</p>}
        {error && <div className="mt-4"><ErrorBox error={error} /></div>}
        <form onSubmit={submit} className="mt-5 space-y-4">
          <Field label="Invite token"><Input value={token} onChange={(e) => setToken(e.target.value)} required data-testid="invite-token" /></Field>
          <Field label="Your name"><Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="invite-name" /></Field>
          <Field label={preview?.existing_user ? "Your existing password" : "Create a password"} hint="At least 12 characters with upper, lower case and a number.">
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={12} data-testid="invite-password" />
          </Field>
          <Button type="submit" className="w-full" disabled={busy || !preview} data-testid="invite-submit">{busy ? "Joining…" : "Accept invitation"}</Button>
        </form>
      </div>
    </div>
  );
}
